export enum SkinFitType{
  ACNE = 0,
  BLACKHEAD = 1,
  PORES_FOREHEAD = 2,
  EYE_POUCH = 3,
  DARK_CIRCLE = 4,
  SKIN_SPOT = 5,
  CROWS_FEET = 6,
  SKIN_COLOR_DARK = 7,
  SKIN_COLOR_BROWN = 8,
  SKIN_COLOR_LIGHT = 9,
}
